// extracted by mini-css-extract-plugin
export default {"component":"PosPage_component__tCS75","horizontal":"PosPage_horizontal__a9ZlJ","vertical":"PosPage_vertical__py4xx"};